import { Extension } from '@tiptap/core';
import uploadDeviation from './uploadDeviation';
export const DndUpload = Extension.create({
    name: 'dnd-upload',
    addCommands () {
        return {
            daUploadFile: (file)=>({ editor, dispatch, state })=>{
                    if (dispatch) {
                        // Insert the spinner
                        const { tr } = state;
                        tr.replaceSelectionWith(editor.schema.nodes.spinner.create());
                        dispatch(tr);
                        uploadDeviation({
                            file,
                            editor
                        }).then((deviation)=>{
                            const chain = editor.chain().focus();
                            chain.selectLastSpinner();
                            if (deviation) {
                                chain.daDeviationAddDeviation(deviation);
                            }
                            chain.run();
                        });
                    }
                    return true;
                }
        };
    }
});

//# sourceMappingURL=dnd-upload.js.map